// extracted by mini-css-extract-plugin
export default {"description":"AvailableTime_description__JCSQw"};